import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss'],
  standalone: false
})
export class ImagePreviewComponent implements OnInit {

  @Input() imageUrl: string;
  @Input() altText?: string;

  constructor(private modalCtrl: ModalController) { }

  dismiss(): void {
    this.modalCtrl.dismiss();
  }

  ngOnInit() { }

}
